import React, { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import Button from '@Components/Buttons/Button'

interface BulkAmendmentTableFooterProps {
    displayNextButton: boolean
    submitAmendments: () => void
}

const BulkAmendmentTableFooter = (props: BulkAmendmentTableFooterProps) => {
    const { displayNextButton, submitAmendments } = props
    const { overclaimSearchBulkActionStore, userStore } = useContext<RootStore>(StoresContext)
    return (
        <div className="footer">
            {displayNextButton && !overclaimSearchBulkActionStore.isAmendmentInReview && (
                <Button
                    className="next"
                    mainColor
                    type="primary"
                    onClick={() => overclaimSearchBulkActionStore.setIsAmendmentInReview(true)}
                >
                    Next
                </Button>
            )}
            {overclaimSearchBulkActionStore.isAmendmentInReview && (
                <>
                    <Button
                        mainColor
                        type="secondary"
                        onClick={() => overclaimSearchBulkActionStore.setIsAmendmentInReview(false)}
                    >
                        Back
                    </Button>
                    <Button mainColor type="primary" disabled={userStore.isInternal} onClick={submitAmendments}>
                        Submit Share Amendments
                    </Button>
                </>
            )}
        </div>
    )
}
export default BulkAmendmentTableFooter
